class HTTPService {
    formatRejectResponse(errorName = 'unknowError', response = {}) {
        const error = new Error(errorName);

        error.response = response;

        return error;
    }
}

export default new HTTPService();



// WEBPACK FOOTER //
// ./src/services/HTTPService/HTTPService.js